module.exports = __webpack_public_path__ + "img/happytable_product1.98af35be.png";